import { HttpErrorResponse } from '@angular/common/http';
import type { LeaderboardUnavailableReason } from '../../../domain/leaderboard/models/leaderboard-unavailable.model';

function readErrorMessage(err: HttpErrorResponse): string {
  const body = err.error;
  if (body == null) {
    return '';
  }
  if (typeof body === 'string') {
    return body;
  }
  if (typeof body.message === 'string') {
    return body.message;
  }
  return '';
}

/**
 * Maps ms-leaderboard-events public read errors to landing unavailable reasons.
 * @see back/crm/ms-leaderboard-events/internal/infra/adapters/primary/api_rest/httperrors/httperrors.go
 */
export function mapPublicLeaderboardHttpError(err: unknown): LeaderboardUnavailableReason {
  if (!(err instanceof HttpErrorResponse)) {
    return 'network_error';
  }
  if (err.status === 0) {
    return 'network_error';
  }
  if (err.status === 404) {
    return 'not_found';
  }
  if (err.status === 409) {
    const message = readErrorMessage(err).toLowerCase();
    if (message.includes('cancelad')) {
      return 'board_cancelled';
    }
    return 'not_playable';
  }
  if (err.status >= 500) {
    return 'server_error';
  }
  if (err.status === 400) {
    return 'missing_params';
  }
  return 'server_error';
}
